import { gql } from '@apollo/client'

export const SABRE_SIMPLE_PRODUCT_FRAGMENT = gql`
  fragment SimpleProduct on Product {
    id
    name
    preferredName
    packagingName
    upcA
    planogramImageUrl
    marketingImageUrl
    commonName {
      id
      name
    }
    brand {
      name
    }
    manufacturer {
      name
    }
    category {
      name
    }
    packaging {
      quantity
      size
      unit
      packagingString
    }
  }
`
